<template>
  <div class="rating-description">
    <div
      v-if="password"
      class="rating-description__icon"
      @click="$emit('descriptionHintsClick')"
    ></div>
    <transition name="fade">
      <div class="rating-description__tooltip" v-if="isDescriptionHintsOpen">
        <div class="info-hints">
          <div class="info-hints__item">
            {{ $t('changePasswordDescription')['title'] }}
          </div>
          <div
            v-for="(isValid, hintType) in descriptionHintsValidity"
            :key="hintType"
            class="info-hints__item"
            :class="{ 'info-hints__item--correct': isValid }"
          >
            <div class="info-hints__item-icon"></div>
            {{ $t('changePasswordDescription')[hintType] }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const HINTS_REGEXP = {
  length: /.{8,}/,
  numbers: /[0-9]+/,
  lowercase: /[a-z]+/,
  uppercase: /[A-Z]+/,
  symbols: /[_\W]+/,
};

export default {
  props: {
    password: String,
    isDescriptionHintsOpen: Boolean,
  },

  computed: {
    descriptionHintsValidity() {
      const hintsValidity = {};

      Object.keys(HINTS_REGEXP).forEach((regExpType) => {
        hintsValidity[regExpType] = !!this.password.match(
          /* eslint-disable-next-line */
          HINTS_REGEXP[regExpType]
        );
      });

      return hintsValidity;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.rating-description {
  position: relative;
  height: 24px;

  &__icon {
    width: 14px;
    height: 14px;
    margin-top: 4px;
    background: url('~@/assets/icons/question_mark.svg');
    background-size: cover;
    cursor: pointer;
  }

  &__tooltip {
    width: 201px;
    border-radius: 2px;
    padding: 16px;
    margin-top: 12px;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: $white;
    position: absolute;
    right: -30px;
    z-index: 1;
    box-shadow: 0 0 10px $midle-gray;

    &:before {
      content: '';
      position: absolute;
      right: 36px;
      top: -7px;
    }
  }
}

.info-hints {
  font-size: 12px;
  color: #31393e;

  &__item-icon {
    height: 6px;
    width: 8px;
    margin-right: 11px;
    background: url('~@/assets/icons/incorrect-icon.svg');
    background-size: cover;
  }

  &__item {
    margin: 4px 0;
    font-family: RobotoRegular;
    display: flex;
    align-items: center;

    &--correct {
      color: #0bab4f;

      .info-hints__item-icon {
        background: url('~@/assets/icons/correct-icon.svg');
        background-size: cover;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
